export default __webpack_public_path__ + "b82165ed560ed0de440da87568e35ff0.png";